import { FC } from 'react'

import { Icon } from 'src/components/atoms'

type Props = {
  roleName: string
  size?: 's' | 'm'
  className?: string
}

export const RoleIcon: FC<Props> = ({ roleName, size = 'm', className }) => {
  const loadIcon = (name: string) => {
    if (name === 'superAdmin') {
      return 'monitor/soft/line'
    }
    if (name === 'admin') {
      return 'tool/soft/line'
    }
    return 'user/soft/line'
  }

  return (
    <div className={className}>
      <Icon path={loadIcon(roleName)} size={size === 's' ? '--r1' : '--r2'} />
    </div>
  )
}
